import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { setAddContractModalState } from '../../../redux/slices/components/Rules/rulesSlice';
import { useAppDispatch } from '../../../redux/store/store';
import useCheckAccess from '../../hooks/useCheckAccess/useCheckAccess';

const HeaderRules = () => {

    const { t } = useTranslation();
    const dispatch = useAppDispatch()

    const accessEdit = useCheckAccess({ id_Category: "Rules", id_Policy: "Contracts", id_Action: "Edit" })

    const handleAddCategory = () => {
        dispatch( setAddContractModalState() )
    }

    return (
        <div className="flex flex-jc-sb flex-ai-center pb-6">
            <p className="title-screen">{t("General:label_254")}</p>
            {
                accessEdit &&
                <div className="flex flex-ai-center flex-1">
                    <div>
                        <button 
                            className="btn-beside-title-screen"
                            onClick={handleAddCategory}
                        >
                            <FontAwesomeIcon icon={faPlus} className="fs-18" />
                            <p className="text-btn-title-screen">{t("General:label_257")}</p>
                        </button>
                    </div>
                </div>
            }
        </div>
    )
}

export default React.memo( HeaderRules )